import { createAction } from 'redux-actions'

import * as constants from './constants'

export const setName = createAction(constants.SET_NAME)
export const setEmail = createAction(constants.SET_EMAIL)
export const setPassword = createAction(constants.SET_PASSWORD)
export const setFlow = createAction(constants.SET_FLOW)
export const setHasSocialInvite = createAction(constants.HAS_SOCIAL_INVITE)
export const setUserRoles = createAction(constants.USER_ROLES)
export const setUserId = createAction(constants.USER_ID)

export const checkUniqueEmail = createAction(constants.CHECK_UNIQUE_EMAIL)
export const checkUniqueEmailSuccess = createAction(
  constants.CHECK_UNIQUE_EMAIL_SUCCESS
)
export const checkUniqueEmailFailed = createAction(
  constants.CHECK_UNIQUE_EMAIL_FAILED
)

export const setValidEmail = createAction(constants.SET_VALID_EMAIL)
export const setDisabledEmail = createAction(constants.SET_DISABLED_EMAIL)

export const setAssociatedDomainFound = createAction(
  constants.SET_ASSOCIATED_DOMAIN_FOUND
)
export const findAssociatedDomain = createAction(
  constants.FIND_ASSOCIATED_DOMAIN
)

export const setHidePopup = createAction(constants.SET_HIDE_POPUP)
export const isPopupHidden = createAction(constants.IS_POPUP_HIDDEN)

export const sendFindMyTeamVerificationEmail = createAction(
  constants.SEND_FIND_MY_TEAM_VERIFICATION_EMAIL
)
export const sendFindMyTeamVerificationEmailReset = createAction(
  constants.SEND_FIND_MY_TEAM_VERIFICATION_EMAIL_RESET
)
export const sendFindMyTeamVerificationEmailSuccess = createAction(
  constants.SEND_FIND_MY_TEAM_VERIFICATION_EMAIL_SUCCESS
)
export const sendFindMyTeamVerificationEmailFailure = createAction(
  constants.SEND_FIND_MY_TEAM_VERIFICATION_EMAIL_FAILURE
)

export const updatePassword = createAction(constants.UPDATE_PASSWORD)
export const updatePasswordSuccess = createAction(
  constants.UPDATE_PASSWORD_SUCCESS
)
export const updatePasswordPending = createAction(
  constants.UPDATE_PASSWORD_PENDING
)
export const updatePasswordFailed = createAction(
  constants.UPDATE_PASSWORD_FAILED
)

export const updateUser = createAction(constants.UPDATE_USER)
export const updateUserSuccess = createAction(constants.UPDATE_USER_SUCCESS)
export const updateUserPending = createAction(constants.UPDATE_USER_PENDING)
export const updateUserFailed = createAction(constants.UPDATE_USER_FAILED)

export const updateUserAvatarSuccess = createAction(
  constants.UPDATE_USER_AVATAR_SUCCESS
)
export const updateUserAvatarPending = createAction(
  constants.UPDATE_USER_AVATAR_PENDING
)
export const updateUserAvatarFailed = createAction(
  constants.UPDATE_USER_AVATAR_FAILED
)

export const fetchUser = createAction(constants.FETCH_USER)
export const fetchUserSuccess = createAction(constants.FETCH_USER_SUCCESS)
export const fetchUserPending = createAction(constants.FETCH_USER_PENDING)
export const fetchUserFailed = createAction(constants.FETCH_USER_FAILED)

export const fetchUserWithoutName = createAction(
  constants.FETCH_USER_WITHOUT_NAME
)
export const fetchUserWithoutNameSuccess = createAction(
  constants.FETCH_USER_WITHOUT_NAME_SUCCESS
)
export const fetchUserWithoutNamePending = createAction(
  constants.FETCH_USER_WITHOUT_NAME_PENDING
)
export const fetchUserWithoutNameFailed = createAction(
  constants.FETCH_USER_WITHOUT_NAME_FAILED
)

export const fetchClearbitForEmail = createAction(
  constants.FETCH_CLEARBIT_FOR_EMAIL
)
export const fetchClearbitForEmailSuccess = createAction(
  constants.FETCH_CLEARBIT_FOR_EMAIL_SUCCESS
)
export const fetchClearbitForEmailPending = createAction(
  constants.FETCH_CLEARBIT_FOR_EMAIL_PENDING
)
export const fetchClearbitForEmailFailed = createAction(
  constants.FETCH_CLEARBIT_FOR_EMAIL_FAILED
)

export const setResetToken = createAction(constants.SET_RESET_TOKEN)
export const stageProfilePicture = createAction(constants.STAGE_PROFILE_PICTURE)
export const setSSOProvisionedFlow = createAction(
  constants.SET_SSO_PROVISIONED_FLOW
)
export const setAvatarUrl = createAction(constants.SET_AVATAR_URL)

export const updateUserProperties = createAction(
  constants.UPDATE_USER_PROPERTIES
)
export const updateUserPropertiesSuccess = createAction(
  constants.UPDATE_USER_PROPERTIES_SUCCESS
)
export const updateUserPropertiesPending = createAction(
  constants.UPDATE_USER_PROPERTIES_PENDING
)
export const updateUserPropertiesFailed = createAction(
  constants.UPDATE_USER_PROPERTIES_FAILED
)

export const checkEmailIsSSOEnabled = createAction(
  constants.CHECK_EMAIL_IS_SSO_ENABLED
)
export const checkEmailIsSSOEnabledSuccess = createAction(
  constants.CHECK_EMAIL_IS_SSO_ENABLED_SUCCESS
)
export const checkEmailIsSSOEnabledPending = createAction(
  constants.CHECK_EMAIL_IS_SSO_ENABLED_PENDING
)
export const checkEmailIsSSOEnabledFailed = createAction(
  constants.CHECK_EMAIL_IS_SSO_ENABLED_FAILED
)

export const getLoginUrl = createAction(constants.GET_LOGIN_URL)
export const getLoginUrlSuccess = createAction(constants.GET_LOGIN_URL_SUCCESS)
export const getLoginUrlFailed = createAction(constants.GET_LOGIN_URL_FAILED)

export const setIsCalendarSeatOnboarding = createAction(
  constants.SET_IS_CALENDAR_SEAT_ONBOARDING
)

export const fetchEmailFromRelay = createAction(
  constants.FETCH_EMAIL_FROM_RELAY
)
export const fetchEmailFromRelayPending = createAction(
  constants.FETCH_EMAIL_FROM_RELAY_PENDING
)
export const fetchEmailFromRelaySuccess = createAction(
  constants.FETCH_EMAIL_FROM_RELAY_SUCCESS
)
export const fetchEmailFromRelayFailure = createAction(
  constants.FETCH_EMAIL_FROM_RELAY_FAILED
)

export const setTimedVideoGateSuccess = createAction(
  constants.SET_TIMED_VIDEO_GATE_SUCCESS
)
export const setTimedVideoGatePending = createAction(
  constants.SET_TIMED_VIDEO_GATE_PENDING
)
export const setTimedVideoGateFailure = createAction(
  constants.SET_TIMED_VIDEO_GATE_FAILURE
)
